import React from "react";
import { Typography, Chip, ToggleButton, ToggleButtonGroup, Button } from "@mui/material";
import { CaretLeft, CaretRight, ArrowsClockwise } from "@phosphor-icons/react";
import { useTheme } from "@mui/material/styles";

const CptHeader = (props) => {
  const theme = useTheme();
  const {
    classes,
    noteCompleted,
    associatedSessionNotes,
    currentIndex,
    onChangeNoteIndex,
    videoId,
    serviceType,
    setAssociatedTimesLoading,
    downloadViewOnly,
    miraState,
    onRegenerate,
  } = props;
  const service = videoId ? associatedSessionNotes[currentIndex] : serviceType;
  const clinicianName =
    associatedSessionNotes.length && associatedSessionNotes[currentIndex]
      ? associatedSessionNotes[currentIndex].clinician_name
      : null;
  return (
    <div className={classes.cptHeaderContainer}>
      <div className={classes.cptHeaderTitleContainer}>
        <div className={classes.cptHeader}>
          <div className={classes.cptChip}>
            <Typography component="p" variant="h4" fontFamily={"TestTiemposText"}>
              {service?.description ? `${service.description} Note` : ""}
            </Typography>
            <Chip
              label={noteCompleted ? "Submitted" : "Draft"}
              size="small"
              color={noteCompleted ? "success" : "default"}
              variant="outlined"
              sx={
                noteCompleted
                  ? { backgroundColor: "#E8F5E9" }
                  : {
                      backgroundColor: "#f6f7f8",
                      border: "1px solid #CDD3DA",
                      color: "#31333A",
                    }
              }
            />
          </div>
          <Typography component="p" variant="captionSecondary">
            {service?.code === "00000" || service?.code === "99999" ? " " : service?.code || " "}
            {downloadViewOnly && clinicianName && ` - Submitted by ${clinicianName}`}
          </Typography>
        </div>
      </div>
      {miraState?.response && (
        <Button
          variant="contained"
          color="secondary"
          size="small"
          startIcon={<ArrowsClockwise />}
          sx={{ fontSize: 13, whiteSpace: "nowrap", alignSelf: "center" }}
          onClick={onRegenerate}
        >
          Regenerate Session Note
        </Button>
      )}
      {associatedSessionNotes?.length > 1 && (
        <ToggleButtonGroup
          size="small"
          sx={{
            border: "1px solid",
            borderColor: theme.palette.divider,
            "& .MuiToggleButtonGroup-grouped": {
              border: "none !important",
            },
          }}
        >
          <ToggleButton
            onClick={() => onChangeNoteIndex(currentIndex - 1)}
            disableRipple
            disabled={setAssociatedTimesLoading}
            value="left"
            aria-label="left aligned"
          >
            <CaretLeft size={16} color={theme.palette.text.primary} />
          </ToggleButton>
          <ToggleButton
            onClick={() => onChangeNoteIndex(currentIndex + 1)}
            disableRipple
            disabled={setAssociatedTimesLoading}
            value="center"
            aria-label="centered"
          >
            <CaretRight size={16} color={theme.palette.text.primary} />
          </ToggleButton>
        </ToggleButtonGroup>
      )}
    </div>
  );
};

export default CptHeader;
